/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Boost 214408 */

const customize = {
  searchResultTerms: (componentRegistry) => {
    componentRegistry.useComponentPlugin("Toolbar", {
      name: "Do something",
      enabled: true,
      apply: () => ({
        props: (props) => {
          return props;
        },
        afterRender(element) {
          const toolbarElement = element.getRootElm();
          console.log('123213 toolbar element', toolbarElement);
          setTimeout(()=>{
              if(document.querySelector('.boost-sd__search-result-toolbar-panel')){
                let searchResultToolbar = document.querySelector('.boost-sd__search-result-toolbar-panel');
                let searchResultText = searchResultToolbar.innerText.split('\(')[0];
                if(searchResultText.includes('terms')){
                  let searchTerm = boostSDAppConfig.generalSettings.search_term.replaceAll('+',' ');
                  searchResultToolbar.innerText = searchResultText.replace('\{\{ terms \}\}', searchTerm);              
                }
              }
          }
            ,300);
					
        },
      }),
    });
  },
};
/* Boost 214408 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.searchResultTerms,
]);

